<template>
  <vxe-grid
    ref="table"
    size="mini"
    border="inner"
    resizable
    auto-resize
    highlight-hover-row
    :loading="loading"
    :data="tableData"
    :columns="columns"
    :height="tableHeight"
    :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
    :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    row-id="inspectionWorkshopCode"
    :radio-config="{ trigger: 'row', highlight: true, strict: false }"
    @radio-change="radioChange"
  >
    <template #toolbar_form>
      <slot name="header"></slot>
    </template>
    <template #pager>
      <slot name="pager"></slot>
    </template>

    <template #displayCreate="{ row }">
      <span>{{ row.createByName }}</span>
      <br />
      <span>{{ row.createTime }}</span>
    </template>

    <template #displayModify="{ row }">
      <span>{{ row.modifyByName }}</span>
      <br />
      <span>{{ row.modifyTime }}</span>
    </template>

    <template #empty>
      <div class="text-center">
        <img src="/image/static/img/nodata.png" />
        <p class="m-0 mt-2">
          {{ $l('INDEX.table_label_empty') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>

<script>
import tableColumns from './table-columns'

export default {
  props: {
    tableHeight: { type: Number, default: 420 },
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  computed: {
    columns() {
      return tableColumns(this)
    },
  },
  methods: {
    radioChange({ newValue }) {
      this.$emit('chooseChange', newValue || null)
    },
    clearRadioRow() {
      if (!this.$refs.table) return
      this.$refs.table.clearRadioRow()
      this.$emit('chooseChange', null)
    },
  },
}
</script>
